'use client';

import { defineStyleConfig, Flex, useStyleConfig } from '@chakra-ui/react';

import Icon, { IconName } from '@/components/atomic/v1/icon/Icon';

type InfoCalloutColor = 'green' | 'red' | 'yellow' | 'blue';

export type InfoCalloutProps = {
  variant: InfoCalloutColor;
  children: React.ReactNode;
  iconName: IconName;
};

export const infoCalloutTheme = defineStyleConfig({
  variants: {
    green: {
      backgroundColor: 'status/success/bg'
    },
    red: {
      backgroundColor: 'status/error/bg'
    },
    yellow: {
      backgroundColor: 'status/warning/bg'
    },
    blue: {
      backgroundColor: 'status/information/bg'
    }
  }
});
const InfoCallout = ({ variant, children, iconName }: InfoCalloutProps) => {
  const styles = useStyleConfig('InfoCallout', { variant });

  return (
    <Flex columnGap={4} padding={4} borderRadius={10} alignItems="center" sx={styles}>
      <Icon
        boxSizing="content-box"
        flexShrink={0}
        alignSelf="flex-start"
        padding={3}
        background="background/white"
        borderRadius={10}
        name={iconName}
        color="icon/default"
        size={24}
      />
      {children}
    </Flex>
  );
};

export default InfoCallout;
